import React from 'react'
import {
  AuthLayoutWrapper,
  ContentContainer,
  FormContainer
} from 'iebt-zing-storybook/dist/pages/Layout/TeiaAuthPageLayout/style'
import { EspacoTeiaAuthBg, EspacoTeiaAuthLogoImg, EspacoTeiaAuthLogoLink, ESPACO_TEIA_LOGO_URL } from './espacoTeiaBranding.styles'

type EspacoTeiaAuthPageLayoutProps = {
  children?: React.ReactNode
}

export const EspacoTeiaAuthPageLayout = ({ children }: EspacoTeiaAuthPageLayoutProps): JSX.Element => {
  return (
    <AuthLayoutWrapper>
      <EspacoTeiaAuthBg />
      <ContentContainer>
        <EspacoTeiaAuthLogoLink href="/">
          <EspacoTeiaAuthLogoImg src={ESPACO_TEIA_LOGO_URL} alt="Espaço TEIA" />
        </EspacoTeiaAuthLogoLink>
        <FormContainer>{children}</FormContainer>
      </ContentContainer>
    </AuthLayoutWrapper>
  )
}
